import {
  EMPLOYEE_SERVICE_CATEGORY,
  FIXED_SERVICE_CATEGORIES,
  UNSERVICEABLE_STATUS_CODES,
} from '../constants.js';

const NICKNAME_PLACEHOLDER = 'Ja';

/**
 * @property {string} sn
 * @property {string} subscriptionId
 * @property {string} nickname
 * @property {string} category
 * @property {string} switchOnDate
 * @property {boolean} isLoggedIn
 * @property {boolean} isSuspended
 */
export default class SnData {
  /**
   * @param {{
   *   billingType: string,
   *   category: string,
   *   customerId: string,
   *   id: string,
   *   owner: { fullName: string },
   *   paidBy: { id: number },
   *   resource: { installedResource: { "@type": string, subscriptionNumber: string } }[],
   *   status: string
   *   switchOnDate: string
   * }} subscriptionInfoSearch
   * @param {{
   *   cn: string,
   *   isCustomerAdmin: boolean,
   *   isPrepaid: boolean,
   *   sn: string,
   *   subAccount: string,
   *   subId: string
   * }} userData
   */
  constructor({ subscriptionInfoSearch, userData }) {
    this.sn = subscriptionInfoSearch.resource[0].installedResource.subscriptionNumber;
    this.subscriptionId = subscriptionInfoSearch.id;
    this.nickname = subscriptionInfoSearch.owner.fullName ?? NICKNAME_PLACEHOLDER; // For prepaid users who don't have a nickname
    this.category = subscriptionInfoSearch.category;
    this.switchOnDate = subscriptionInfoSearch.switchOnDate;
    this.isLoggedIn = this.sn === userData.sn;
    this.isSuspended = UNSERVICEABLE_STATUS_CODES.includes(subscriptionInfoSearch.status);
  }

  /**
   * @returns {boolean}
   */
  get isFixed() {
    return FIXED_SERVICE_CATEGORIES.includes(this.category);
  }

  /**
   * @returns {boolean}
   */
  get isOskEmployee() {
    return this.category === EMPLOYEE_SERVICE_CATEGORY;
  }
}
